import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingResponseMessageType from 'owa-service/lib/contract/MeetingResponseMessageType';
import MeetingMessageActionEntrySource from '../../store/schema/MeetingMessageActionEntrySource';
import SummaryRow from './SummaryRow';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import EditEventLink from '../EditEventLink';
import { editLinkText } from './MeetingMessageSummary.locstring.json';
import loc from 'owa-localize';

const styles = require('./MeetingMessageSummary.scss');

export interface MeetingResponseSummaryProps {
    item: MeetingResponseMessageType;
    entrySource: MeetingMessageActionEntrySource;
}

const MeetingResponseSummary = observer(function MeetingResponseSummary(
    props: MeetingResponseSummaryProps
) {
    const { item, entrySource } = props;

    const hasTimeProposal = item.ProposedStart && item.ProposedEnd;

    return (
        <SummaryRow item={item}>
            {hasTimeProposal && (
                <div className={styles.responseTimeContainer}>
                    <div>{formatMeetingTimeSpan(item.ProposedStart, item.ProposedEnd)}</div>
                    {item.IsOrganizer && (
                        <EditEventLink
                            item={item}
                            entrySource={entrySource}
                            editLinkClassName={styles.editLink}
                            editLinkText={loc(editLinkText)}
                        />
                    )}
                </div>
            )}
        </SummaryRow>
    );
});

export default MeetingResponseSummary;
